(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-category-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lab-example-gallery')) {
  customElements.define('lab-example-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.lab-gallery__track');
      const slides = [...this.querySelectorAll('.lab-gallery__slide')];
      if (slides.length < 2) return;
      const controls = this.querySelector('.lab-gallery__controls');
      const toggle = this.querySelector('[data-pause]');
      const count = this.querySelector('.lab-gallery__count');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, paused = this.dataset.autoplay !== 'true' || motion.matches, hovered = false, visible = false;
      const updateButton = () => { toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; };
      const stop = () => { paused = true; updateButton(); };
      const update = () => {
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        count.textContent = `${index + 1} / ${slides.length}`;
        slides.forEach((slide, i) => { slide.inert = i !== index; });
      };
      const go = (step) => { index = (index + step + slides.length) % slides.length; track.scrollTo({left: index * track.clientWidth, behavior: motion.matches ? 'instant' : 'smooth'}); };
      controls.hidden = false;
      updateButton(); update();
      this.querySelector('[data-prev]').addEventListener('click', () => { stop(); go(-1); }, {signal});
      this.querySelector('[data-next]').addEventListener('click', () => { stop(); go(1); }, {signal});
      toggle.addEventListener('click', () => { paused = !paused; updateButton(); }, {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      track.addEventListener('pointerdown', stop, {passive:true, signal});
      track.addEventListener('wheel', stop, {passive:true, signal});
      track.addEventListener('keydown', e => { if (['ArrowLeft','ArrowRight'].includes(e.key)) { e.preventDefault(); stop(); go(e.key === 'ArrowRight' ? 1 : -1); } }, {signal});
      this.addEventListener('focusin', e => { if (e.target !== toggle) stop(); }, {signal});
      this.addEventListener('mouseenter', () => { hovered = true; }, {signal});
      this.addEventListener('mouseleave', () => { hovered = false; }, {signal});
      motion.addEventListener('change', () => { if (motion.matches) stop(); }, {signal});
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:.25});
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => { track.scrollTo({left:index * track.clientWidth, behavior:'instant'}); });
      this.resize.observe(track);
      this.timer = setInterval(() => { if (!paused && !hovered && visible && !document.hidden) go(1); }, 6000);
      this.addEventListener('shopify:block:select', e => { const target = e.target.closest('.lab-gallery__slide'); const n = slides.indexOf(target); if (n >= 0) { stop(); index = n; track.scrollTo({left:index * track.clientWidth, behavior:'instant'}); } }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; clearInterval(this.timer); this.observer?.disconnect(); this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tablolab-vitrin"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-vitrin')) {
  customElements.define('tl-vitrin', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.tabs = Array.from(this.querySelectorAll('[data-go]'));
      this.index = 0;
      this.paused = this.dataset.rotate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort = new AbortController();
      const on = (node, event, fn) => node?.addEventListener(event, fn, { signal: this.abort.signal });
      this.querySelector('[data-controls]').hidden = this.slides.length < 2;
      this.tabs.forEach((button, index) => on(button, 'click', () => this.show(index, true)));
      on(this.querySelector('[data-pause]'), 'click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.start();
      });
      on(this, 'pointerenter', () => this.stop());
      on(this, 'pointerleave', () => this.start());
      on(this, 'focusin', event => { this.stop(); if (!event.target.closest('[data-pause]')) { this.paused = true; this.updatePause(); } });
      on(document, 'visibilitychange', () => document.hidden ? this.stop() : this.start());
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index >= 0) this.show(index, true);
      });
      let x = null, y = null;
      on(this, 'touchstart', event => { x = event.touches[0].clientX; y = event.touches[0].clientY; this.stop(); });
      on(this, 'touchend', event => {
        if (x === null) return;
        const dx = event.changedTouches[0].clientX - x;
        const dy = event.changedTouches[0].clientY - y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.show(this.index + (dx < 0 ? 1 : -1), true);
        x = null; y = null; this.start();
      });
      this.updatePause();
      this.start();
    }
    show(index, manual) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, n) => { slide.hidden = n !== this.index; slide.inert = n !== this.index; });
      this.tabs.forEach((button, n) => button.setAttribute('aria-pressed', String(n === this.index)));
      if (manual) {
        this.paused = true;
        this.updatePause();
        this.querySelector('[data-status]').textContent = this.slides[this.index].dataset.name;
      }
      this.start();
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.querySelector('path').setAttribute('d', this.paused ? 'M9 5l10 7-10 7V5Z' : 'M9 6v12M15 6v12');
    }
    start() {
      this.stop();
      if (!this.paused && !document.hidden && !this.matches(':hover') && this.slides.length > 1) this.timer = setTimeout(() => this.show(this.index + 1, false), Number(this.dataset.interval) || 8000);
    }
    stop() { clearTimeout(this.timer); }
    disconnectedCallback() { this.stop(); this.abort?.abort(); this.ready = false; }
  });
}


  } catch(e) { console.error(e); }
})();
})();
